<template>
    <div class="manual-item-edit-form">
        <div style="flex-basis: 80px; width: 100%;"
             class="pa-0">
            <input
                ref="titleInput"
                v-model="manualItem.title"
                placeholder="..." class="edit-form__title" @keydown="onKeydownTitle">
            <div class="edit-form__title__border"></div>
        </div>
        <div style="flex-grow: 1; display: flex; justify-content: flex-end; width: 100%;"
             class="pa-0">
            <quill-editor
                ref="editor"
                v-model="manualItem.content"
                :options="{}"
                style="width: 100%; height: calc(100% - 68.9px); background-color: #ffffff;"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "ManualItemEditForm",
    props: {
        manualItem: undefined,
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            titleFocused: false,
            contentFocused: false,
        };
    },
    watch: {
        isSelected() {
            this.forceFocus();
        },
    },
    mounted() {
        this.$refs.titleInput && this.$refs.titleInput.addEventListener("focus", e => {
            this.$emit("focus");
            this.titleFocused = true;
            this.contentFocused = false;
        });
        this.$refs.titleInput && this.$refs.titleInput.addEventListener("blur", e => {
            this.titleFocused = false;
            this.$emit("blur");
        });
        const editor = this.$refs.editor.$el.querySelector(".ql-editor");
        editor && editor.addEventListener("focus", e => {
            this.$emit("focus");
            this.titleFocused = false;
            this.contentFocused = true;
        });
        editor && editor.addEventListener("blur", e => {
            this.contentFocused = false;
            this.$emit("blur");
        });
        this.forceFocus();
    },
    methods: {
        forceFocus() {
            if (this.isSelected) {
                if (this.contentFocused) {
                    const editor = this.$refs.editor.$el.querySelector(".ql-editor");
                    editor && editor.focus();
                } else {
                    this.$refs.titleInput && this.$refs.titleInput.focus();
                }
            }
        },

        onKeydownTitle(e) {
            const editor = this.$refs.editor.$el.querySelector(".ql-editor");

            switch (e.keyCode) {
                case 13: // Enter
                case 40: // ArrowDown
                    e.preventDefault();
                    editor.focus();
                    break;
                case 38: // ArrowUp
                    this.$emit("arrow:up");
                    break;
            }
        }
    },
}
</script>

<style scoped>
.manual-item-edit-form {
    border-left: 5px solid rgb(248, 248, 248);
}

.manual-item-edit-form:focus-within {
    border-left: 5px solid mediumpurple;
}

>>> .ql-toolbar {
    /*display: none;*/
}

>>> .ql-container {
    border: none;
}

>>> .ql-bold {
    display: none !important;
}

>>> .ql-italic {
    display: none !important;
}

>>> .ql-underline {
    display: none !important;
}

>>> .ql-strike {
    display: none !important;
}

>>> .ql-script {
    display: none !important;
}

>>> .ql-size {
    display: none !important;
}

>>> .ql-font {
    display: none !important;
}

>>> .ql-color {
    display: none !important;
}

>>> .ql-background {
    display: none !important;
}

.edit-form__title {
    width: 100%;
    outline: none;
    background: white;
    height: 60px;
    font-size: 20px;
    padding: 0 16px;
}

.edit-form__title__border {
    //border-bottom: 1px solid #ddd;
    width: calc(100% - 32px);
    min-height: 1px;
    margin: 0 16px;
}
</style>